@if (ready() && isInSelfServeArea()) {
  @for (job of notifications().slice().reverse(); track job.callUuid) {
    <qai-alert
      [kind]="
        job.status === SimulationGenerationStatus.Completed
          ? 'success'
          : 'error'
      "
      [title]="
        (job.status === SimulationGenerationStatus.Completed
          ? 'simulationBuilder.SIMULATION_DOCUMENTS_PROCESSED_TITLE'
          : 'simulationBuilder.SIMULATION_DOCUMENTS_FAILED_TITLE'
        ) | transloco
      "
      (closeClick)="dismiss(job.callUuid)"
    >
      {{
        (job.status === SimulationGenerationStatus.Completed
          ? "simulationBuilder.SIMULATION_DOCUMENTS_PROCESSED_BODY"
          : job.reason === 'DOCUMENT_PARSE_FAILED'
            ? "simulationBuilder.SIMULATION_DOCUMENTS_PARSE_FAILED_BODY"
            : "simulationBuilder.SIMULATION_DOCUMENTS_FAILED_BODY"
        ) | transloco: { name: job.simulationName }
      }}
      <div class="banner-actions">
        <button
          qai-button
          kind="tertiary-text"
          size="small"
          (click)="dismiss(job.callUuid)"
        >
          {{ "simulationBuilder.DISMISS" | transloco }}
        </button>
        <button
          qai-button
          kind="tertiary-text"
          size="small"
          class="view-simulation-link"
          (click)="
            job.status === SimulationGenerationStatus.Completed
              ? handleViewSimulationClick(
                  job.callUuid,
                  job.moduleUuid,
                  job.simulationStatus
                )
              : handleViewDocumentsClick(job.callUuid)
          "
        >
          {{
            (job.status === SimulationGenerationStatus.Completed
              ? "simulationBuilder.VIEW_SIMULATION"
              : "simulationBuilder.VIEW_DOCUMENTS"
            ) | transloco
          }}
        </button>
      </div>
    </qai-alert>
  }
}
